import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuCollapsible, SidebarMenuItem } from 'app/domains/common-ui';
import { InsightsTemplate } from 'app/domains/insights';
import { useListDashboards } from './useListDashboards';
import { useDesktopNavigation } from '../../../DesktopNavigation';
import { CollapsibleItemLink } from '../CollapsibleItemLink';
import { useLinkMatch } from '../useLinkMatch';
export function CollapsibleInsights() {
    const { collapsibleStates, toggleCollapsible } = useDesktopNavigation();
    const { data, loading } = useListDashboards();
    const [open, setOpen] = useState(false);
    const activeChild = useLinkMatch({
        matchPath: ['/insights'],
        matchExact: false,
    });
    const handleShowTemplates = () => setOpen(true);
    if (loading) {
        return null;
    }
    if (!data.length) {
        return (<Fragment>
        <SidebarMenuItem icon={<Falcon icon="chart-simple"/>} label={t({ comment: 'Sidebar menu - Insights label', message: 'Insights', context: 'sidebar' })} onClick={handleShowTemplates}/>
        {open && <InsightsTemplate onClose={() => setOpen(false)}/>}
      </Fragment>);
    }
    return (<SidebarMenuCollapsible icon={<Falcon icon="chart-simple"/>} label={t({ comment: 'Sidebar menu - Insights label', message: 'Insights', context: 'sidebar' })} activeChild={activeChild} collapsibleKey="insights" open={collapsibleStates.insights} onToggle={toggleCollapsible}>
      {data.map((dashboard) => (<CollapsibleItemLink key={dashboard.id} to={`/insights/${dashboard.id}`} label={dashboard.label} matchPath={`/insights/${dashboard.id}`}/>))}
    </SidebarMenuCollapsible>);
}
